var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10547 6.50342H5.4034M2.10547 10.9007H4.30409M8.72332 8.48328L8.06373 15.0791C8.03317 15.3848 8.06699 15.6934 8.16301 15.9852C8.25904 16.277 8.41513 16.5454 8.62124 16.7732C8.82735 17.0009 9.0789 17.183 9.35966 17.3075C9.64043 17.4321 9.94419 17.4965 10.2514 17.4965H19.0239C19.5691 17.4965 20.0948 17.2939 20.4991 16.928C20.9033 16.5622 21.1572 16.0592 21.2115 15.5167L21.8711 8.9208C21.9016 8.61516 21.8678 8.3065 21.7718 8.01472C21.6758 7.72295 21.5197 7.45453 21.3136 7.22678C21.1074 6.99903 20.8559 6.81699 20.5751 6.6924C20.2944 6.56781 19.9906 6.50343 19.6834 6.50342H10.9109C10.3657 6.50344 9.83995 6.70604 9.43571 7.0719C9.03146 7.43775 8.77757 7.94076 8.72332 8.48328Z",
    stroke: "#6B6B6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58008 7.05371L12.8582 10.6594C13.1495 10.98 13.5011 11.2399 13.8929 11.4245C14.2847 11.6092 14.709 11.7148 15.1417 11.7354C15.5743 11.756 16.0067 11.6912 16.4143 11.5447C16.8219 11.3982 17.1966 11.1729 17.5171 10.8815L21.1228 7.60337",
    stroke: "#6B6B6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.a6d5a82c73c7c0a69d9f21a469cffe63.svg";
export { ForwardRef as ReactComponent };